import useModal from '@/hooks/use-modal/index'
import classname from 'classnames'
import moment from 'moment'
import PropTypes from 'prop-types'
import { Fragment, useState } from 'react'
import ViewFullMessage from './view-message-activity-log-modal.jsx'
import { featureConstant } from "@/constants/configuration/feature.js";
import { useFeature } from "@/hooks/use-feature/index";
import { renderUserEmailStacked } from '@/utils/formatUserEmail';

const ActivityLog = ({ title, activity }) => {
	const isSoftDeleteUserEnabled = useFeature(featureConstant.SOFT_DELETE_USER);
	const [loadMore, setLoadMore] = useState(false)
	const [selectedData, setSelectedData] = useState()

	const {
		visible: isViewFullMessageVisible,
		show: showViewFullMessage,
		hide: hideViewFullMessage,
	} = useModal()

	const loadMoreClass = classname({
		'eclip-audit-log-wrapper': true,
		'eclip-audit-load-more--scroll': loadMore,
	})

	const auditData = activity?.map((item, _index) => {
		return (
			<Fragment key={_index}>
				<div className="eclip-activity-log-container">
				{/* <span style={borderStyle}></span> */}
				<div className="eclip-activity-log--label eclip-modal-flex">
					<span className="eclip-activity-log---text">{item?.activity}</span>
					{item?.moreInfo && (
					<>
						<span
						className="eclip-modal--view-message"
						onClick={() => {
							setSelectedData(item)
							showViewFullMessage()
						}}
						>
						View Message
						</span>
					</>
					)}
				</div>
				<div className="package-activity-log--subcontent">
					<span>
					{moment(new Date(item?.timestamp)).format('DD MMM, HH:mm')}
					</span>
					<span title={item?.orgName}>{item?.orgName}</span>
					<div className={`soft-delete__tooltip-container__eclip-width ${isSoftDeleteUserEnabled ? 'soft-delete__tooltip-container' : ''}`}>{isSoftDeleteUserEnabled ? renderUserEmailStacked(item?.user) : item?.user}
						{isSoftDeleteUserEnabled && item?.user?.user_status === 'DELETED' && <div className="tooltiptexts eform-tooltip-text">{renderUserEmailStacked(item?.user)}</div>}</div>
				</div>

				<hr />
				</div>
			</Fragment>
		)
	})

	const NoMessage = () => {
		return (
			<div className="eclip-activity-log--no-messgaes">No Data Available</div>
		)
	}

	return (
		<>
			<div className="eclip-activity-log">
				<div className="eclip-receipient__title">{title}</div>

				{activity?.length > 0 ? (
				<>
					<div className={loadMoreClass}>{auditData}</div>
					{activity?.length > 4 && (
					<>
						{!loadMore && (
						<div
							className="eclip-audit-load-more"
							onClick={() => setLoadMore(!loadMore)}
						>
							Load More
						</div>
						)}
					</>
					)}
				</>
				) : (
				<NoMessage />
				)}
			</div>

			<ViewFullMessage
				visible={isViewFullMessageVisible}
				close={hideViewFullMessage}
				data={selectedData}
			/>
		</>
	)
}

ActivityLog.propTypes = {
    title: PropTypes.string,
    activity: PropTypes.arrayOf(PropTypes.shape({
        activity: PropTypes.string.isRequired,
        moreInfo: PropTypes.bool,
        timestamp: PropTypes.string.isRequired,
        orgName: PropTypes.string,
        user: PropTypes.string,
    })),
}

export default ActivityLog
